import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

export default function AdminDialog({ title, description, onClose, children, wide, testid }) {
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className={`${wide ? "max-w-3xl" : "max-w-lg"} max-h-[90vh] overflow-y-auto bg-[#0E0E16] border-[#D4AF37]/30 text-gray-100`} data-testid={testid}>
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">{title}</DialogTitle>
          <DialogDescription className="text-gray-400">{description || " "}</DialogDescription>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}

export function Field({ label, children }) {
  return <div><label>{label}</label><div className="mt-1">{children}</div></div>;
}

export function DialogButtons({ onClose, testid, saveLabel = "Сохранить" }) {
  return (
    <div className="flex gap-3 justify-end pt-2">
      <button type="button" onClick={onClose} className="btn-outline" data-testid={`${testid}-cancel-btn`}>Отмена</button>
      <button type="submit" className="btn-gold" data-testid={`${testid}-save-btn`}>{saveLabel}</button>
    </div>
  );
}

export function Toggle({ checked, onChange, label, testid }) {
  return (
    <label className="flex items-center gap-2 !normal-case !tracking-normal text-sm text-gray-200 cursor-pointer">
      <input type="checkbox" className="!w-4 !h-4" checked={!!checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid} />
      {label}
    </label>
  );
}
